import { Link } from 'react-router-dom';

interface SectionTitleProps {
  title: string;
  subtitle?: string;
  moreTo?: string;
  moreLabel?: string;
  icon?: string;
}

export default function SectionTitle({
  title,
  subtitle,
  moreTo,
  moreLabel = '查看更多',
  icon,
}: SectionTitleProps) {
  return (
    <div className="mb-5 flex items-end justify-between gap-4">
      <div>
        <h2 className="flex items-center gap-2 font-heading text-xl font-bold text-foreground-50 md:text-2xl">
          {icon && (
            <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary-500/15 text-primary-400">
              <i className={`${icon} text-lg`} />
            </span>
          )}
          {title}
        </h2>
        {subtitle && <p className="mt-1.5 text-sm text-foreground-400">{subtitle}</p>}
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="flex shrink-0 items-center gap-1 whitespace-nowrap text-sm font-medium text-foreground-400 transition-colors hover:text-primary-400"
        >
          {moreLabel}
          <i className="ri-arrow-right-s-line text-lg" />
        </Link>
      )}
    </div>
  );
}